import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updEventData } from "../../../../ReduxSlice/Event/eventSlice";
import ModalWrapper from "../../../Common/Portals/ModalWrapper";
import useHttpHook from "../../../../Hooks/HttpHook";
import Input from "../../../UiElement/FormElement/Input";
import MainComponentWrapper from "../../../Common/MainComponentWrapper";
import { TicketFormLanguage } from "../../../../utils/Languages";
import { useEffect, useState } from "react";
import { createTicketApi } from "../../../../utils/ApiConstant";
import { toast } from "react-toastify";
import moment, { min } from "moment";
import {
  combineDateTime,
  formatDateInputValidation,
  formatDateInputValidationWithMin,
} from "../../../../utils/Helper";
import { showErrorToast } from "../../../../utils/notify";

const VALIDITY_ERRORS = {
  endAfterEvent:
    "Valid till must be on or before the event end date and time.",
  startBeforeEvent:
    "Valid from must be on or after the event start date.",
  startBeforeEnd: "Valid from must be before valid till.",
  tillAfterEventStart:
    "Valid till must be after the event start date and time.",
  tillBeforeEventStart:
    "Valid till must be on or after the event start date.",
  startBeforeEventEnd:
    "Valid from must be on or before the event end date.",
  startAfterToday: "Valid from must be today or later.",
};

const getValidityRowErrors = (item = {}) =>
  [
    ...new Set(
      [
        item.startDateError,
        item.currentDateError,
        item.isBeforeEventValidation,
        item.startDateGreater,
        item.error,
        item.isBeforeEventValidationEnd,
        item.isTicketEventStart,
      ].filter(Boolean)
    ),
  ];

const TicketForm = (props) => {
  const [loading, sendRequest, error, successmessage] = useHttpHook();
  const { eventId } = useParams();
  const {
    register,
    handleSubmit,

    formState: { errors },
    reset,
  } = useForm();

  const dispatch = useDispatch();
  const eventData = useSelector((state) => state.event);

  const [ticketStart, setTicketStart] = useState([new Date().toISOString()]);
  const [ticketEnd, setTicketEnd] = useState([new Date().toISOString()]);

  const [minMaxError, setMinMaxError] = useState("");
  const [salesStartError, setSalesStartError] = useState("");
  const [abc, setAbc] = useState([]);
  const [tickets, setTickets] = useState([
    {
      ticketStart: "",
      ticketEnd: "",
    },
  ]);

  const [ticketError, setTicketError] = useState(false);
  const [count, setCount] = useState([0]);
  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);

  const emptyFormValues = {
    name: "",
    quantity: "",
    price: "",
    maxTicketPerOrder: "",
    minTicketPerOrder: "",
    salesEnd: "",
    salesStart: "",
    description: "",
    hotellink: "",
  };

  const resetCreateForm = () => {
    reset(emptyFormValues);
    setTickets([{ ticketStart: "", ticketEnd: "" }]);
    setTicketStart([new Date().toISOString()]);
    setTicketEnd([new Date().toISOString()]);
    setMinMaxError("");
    setSalesStartError("");
    setTicketError(false);
    setAbc([]);
    setCount([0]);
  };

  useEffect(() => {
    if (!props.OpenTicketForm) return;

    if (!props.TicketData) {
      resetCreateForm();
      return;
    }

    const defaultFormValues = {
      name: props.TicketData.name,
      quantity: props.TicketData.quantity,
      price: props.TicketData.price,
      maxTicketPerOrder: props.TicketData.maxTicketPerOrder,
      minTicketPerOrder: props.TicketData.minTicketPerOrder,
      salesEnd: props.TicketData.salesEnd,
      salesStart: props.TicketData.salesStart,
      description: props.TicketData.description,
      hotellink: props.TicketData.hotellink,
    };
    reset(defaultFormValues);
    setMinMaxError("");
    setSalesStartError("");
    setTicketError(false);

    const start = props.TicketData?.ticketStart || [];
    const end = props.TicketData?.ticketEnd || [];
    const startTicketObj = start.reduce(function (result, item, index) {
      result[index] = item;
      return result;
    }, {});

    const endTicketObj = end.reduce(function (result, item, index) {
      result[index] = item;
      return result;
    }, {});

    const a = [];
    Object.keys(startTicketObj)?.map((item) => {
      a.push({ ticketStart: startTicketObj[item], key: item });
    });

    let endRows = [];
    Object.keys(endTicketObj)?.map((item) =>
      endRows.push({ ticketEnd: endTicketObj[item], key: item })
    );

    let k = [];
    a?.map((item) => {
      const exist = endRows.find((s) => s.key === item.key);
      if (exist) {
        k.push({ ticketStart: item.ticketStart, ticketEnd: exist.ticketEnd });
      }
    });

    setTickets(
      k.length > 0 ? k : [{ ticketStart: "", ticketEnd: "" }]
    );
  }, [props.OpenTicketForm, props.TicketData]);

  const onSubmit = async (data) => {
    let eventEndDate = new Date(eventData.data.eventTiming.endDate);
    let eventEndTime = eventData.data.eventTiming.endTime;
    const [hour, minute] = eventEndTime.split(":");
    const eventEndDateTimeCombine = combineDateTime(eventEndDate, hour, minute);
    const eventEndDateTime = moment
      .utc(eventEndDateTimeCombine)
      .format("YYYY-MM-DD HH:mm");

    const eventStartDate = moment(eventData.data.eventTiming.startDate).format(
      "YYYY-MM-DD"
    );
    const salesEndDate = moment(data.salesEnd).format("YYYY-MM-DD");
    const salesStartDate = moment(data.salesStart).format("YYYY-MM-DD");
    const currentDate = moment(new Date()).format("YYYY-MM-DD");

    if (!props.TicketData?._id) {
      if (salesStartDate < currentDate) {
        toast.error("Sales start should be greater than current date");
        return;
      }
    }

    if (props.TicketData) {
      data["_id"] = props.TicketData._id;
    }

    const ticketsError = [];
    await tickets.map((item, i) => {
      const ticketValidityEnd = moment(item.ticketEnd).format("YYYY-MM-DD");
      const ticketValidityEndDateTime = moment(item.ticketEnd).format(
        "YYYY-MM-DD HH:mm"
      );

      const ticketValidityStart = moment(item.ticketStart).format("YYYY-MM-DD");

      const ticketValidityStartDateTime = moment(item.ticketStart).format(
        "YYYY-MM-DD HH:mm"
      );

      if (ticketValidityEndDateTime > eventEndDateTime) {
        setTickets((prev) => {
          const temp = [...prev];
          const exist = temp.find((s, index) => index === i);
          if (exist) {
            exist.error = VALIDITY_ERRORS.endAfterEvent;
            return temp;
          }
        });
        ticketsError.push(`end${i}`);
      } else {
        setTickets((prev) => {
          const temp = [...prev];
          const exist = temp.find((s, index) => index === i);
          if (exist) {
            exist.error = "";
            return temp;
          } else {
            return temp;
          }
        });
        ticketsError.filter((s) => s !== `end${i}`);
      }

      let eventStartDates = new Date(eventData.data.eventTiming.startDate);
      const eventStartTime = eventData.data.eventTiming.startTime;
      const [hour, minute] = eventStartTime.split(":");
      const combinedStartDateTime = combineDateTime(
        eventStartDates,
        hour,
        minute
      );
      const eventStartDateTimes = moment
        .utc(combinedStartDateTime)
        .format("YYYY-MM-DD HH:mm");

      // const eventStartDates = moment(
      //   eventData.data.eventTiming.startDate
      // ).format("YYYY-MM-DD");
      // const eventStartTime = eventData.data.eventTiming.startTime;

      // const [hours, minutes] = eventStartTime.split(":");

      // const combinedStartDateTime = new Date(eventStartDates);

      // combinedStartDateTime.setHours(hours);
      // combinedStartDateTime.setMinutes(minutes);
      // const eventStartDateTimes = moment(combinedStartDateTime).format(
      //   "YYYY-MM-DD HH:mm"
      // );

      // return;

      if (ticketValidityStart < eventStartDate) {
        setTickets((prev) => {
          const temp = [...prev];
          const exist = temp.find((s, index) => index === i);
          if (exist) {
            exist.isBeforeEventValidation = VALIDITY_ERRORS.startBeforeEvent;
            return temp;
          }
        });
        ticketsError.push(`vstart${i}`);
      } else {
        setTickets((prev) => {
          const temp = [...prev];
          const exist = temp.find((s, index) => index === i);
          if (exist) {
            exist.isBeforeEventValidation = "";
            return temp;
          }
        });

        ticketsError.filter((s) => s !== `vstart${i}`);
      }

      if (
        ticketValidityStart >= eventStartDate &&
        ticketValidityEnd >= eventStartDate
      ) {
        if (ticketValidityStartDateTime >= ticketValidityEndDateTime) {
          setTickets((prev) => {
            const temp = [...prev];
            const exist = temp.find((s, index) => index === i);
            if (exist) {
              exist.startDateGreater = VALIDITY_ERRORS.startBeforeEnd;
              return temp;
            }
          });
          ticketsError.push(`strG${i}`);
        } else {
          setTickets((prev) => {
            const temp = [...prev];
            const exist = temp.find((s, index) => index === i);
            if (exist) {
              exist.startDateGreater = "";
              return temp;
            }
          });
          ticketsError.filter((s) => s !== `strG${i}`);
        }
      }

      if (ticketValidityEndDateTime < eventStartDateTimes) {
        setTickets((prev) => {
          const temp = [...prev];
          const exist = temp.find((s, index) => index === i);
          if (exist) {
            exist.isTicketEventStart = VALIDITY_ERRORS.tillAfterEventStart;
            return temp;
          }
        });
        ticketsError.push(`vend${i}`);
      } else {
        setTickets((prev) => {
          const temp = [...prev];
          const exist = temp.find((s, index) => index === i);
          if (exist) {
            exist.isTicketEventStart = "";
            return temp;
          }
        });
        ticketsError.filter((s) => s !== `vend${i}`);
      }

      if (ticketValidityEndDateTime < eventStartDateTimes) {
        setTickets((prev) => {
          const temp = [...prev];
          const exist = temp.find((s, index) => index === i);
          if (exist) {
            exist.isTicketEventStart = VALIDITY_ERRORS.tillAfterEventStart;
            return temp;
          }
        });
        ticketsError.push(`vend${i}`);
      } else {
        setTickets((prev) => {
          const temp = [...prev];
          const exist = temp.find((s, index) => index === i);
          if (exist) {
            exist.isBeforeEventValidationEnd = "";
            return temp;
          }
        });
        ticketsError.filter((s) => s !== `vend${i}`);
      }

      // if (ticketValidityStartDateTime < eventStartDateTimes) {
      //   setTickets((prev) => {
      //     const temp = [...prev];
      //     const exist = temp.find((s, index) => index === i);
      //     console.log(exist, "-------- if ");
      //     if (exist) {
      //       exist.isTicketStartEventStart =
      //         "Validation should be greater than event start date";
      //       return temp;
      //     }
      //   });
      //   ticketsError.push(`vend${i}`);
      // } else {
      //   setTickets((prev) => {
      //     const temp = [...prev];
      //     const exist = temp.find((s, index) => index === i);
      //     if (exist) {
      //       exist.isTicketStartEventStart = "";
      //       return temp;
      //     }
      //   });
      //   ticketsError.filter((s) => s !== `vend${i}`);
      // }

      if (ticketValidityEnd < eventStartDate) {
        setTickets((prev) => {
          const temp = [...prev];
          const exist = temp.find((s, index) => index === i);
          if (exist) {
            exist.isBeforeEventValidationEnd = VALIDITY_ERRORS.tillBeforeEventStart;
            return temp;
          }
        });
        ticketsError.push(`vend${i}`);
      } else {
        setTickets((prev) => {
          const temp = [...prev];
          const exist = temp.find((s, index) => index === i);
          if (exist) {
            exist.isBeforeEventValidationEnd = "";
            return temp;
          }
        });
        ticketsError.filter((s) => s !== `vend${i}`);
      }

      if (ticketValidityStart > eventEndDate) {
        setTickets((prev) => {
          const temp = [...prev];
          const exist = temp.find((s, index) => index === i);
          if (exist) {
            exist.startDateError = VALIDITY_ERRORS.startBeforeEventEnd;
            return temp;
          }
        });
        ticketsError.push(`start${i}`);
      } else {
        setTickets((prev) => {
          const temp = [...prev];
          const exist = temp.find((s, index) => index === i);
          if (exist) {
            exist.startDateError = "";
            return temp;
          } else {
            return temp;
          }
        });
        ticketsError.filter((s) => s !== `start${i}`);
      }

      if (!props.TicketData) {
        if (ticketValidityStart < currentDate) {
          setTickets((prev) => {
            const temp = [...prev];
            const exist = temp.find((s, index) => index === i);
            if (exist) {
              exist.currentDateError = VALIDITY_ERRORS.startAfterToday;
              return temp;
            }
          });

          ticketsError.push(`current${i}`);
        } else {
          setTickets((prev) => {
            const temp = [...prev];
            const exist = temp.find((s, index) => index === i);
            if (exist) {
              exist.currentDateError = "";
              return temp;
            } else {
              return temp;
            }
          });
          ticketsError.filter((s) => s !== `current${i}`);
        }
      }
    });

    if (ticketsError.length) return;

    if (tickets[0].ticketStart === "" || tickets[0].ticketEnd === "") {
      toast.error("Please select ticket start and end date");
      return;
    }

    data = {
      ...data,
      ticketStart: tickets.map((item) => item.ticketStart),
      ticketEnd: tickets.map((item) => item.ticketEnd),
    };

    let event = await sendRequest(createTicketApi + eventId, {
      method: "post",
      data,
    });

    if (event.status === 1) {
      dispatch(updEventData(event));
      resetCreateForm();
      props.CloseModal();
    }
  };

  const eventEndDateTime = formatDateInputValidation(
    eventData?.data?.eventTiming?.endDate
  );

  const eventStartDateTime = formatDateInputValidationWithMin(
    eventData?.data?.eventTiming?.startDate
  );

  return (
    <MainComponentWrapper
      Loading={loading}
      errorInfo={error}
      successMsg={successmessage}
    >
      <ModalWrapper
        title={TicketFormLanguage.PopUpTitle}
        OverRideModal={true}
        size="lg"
        ShowModal={props.OpenTicketForm}
        CloseModalHandler={() => {
          resetCreateForm();
          props.CloseModal();
        }}
        dialogClassName="event-ticket-modal-dialog"
        contentClassName="event-ticket-modal"
        headerClassName="event-ticket-modal-header"
        bodyClassName="event-ticket-modal-body"
        footerClassName="event-ticket-modal-footer"
        closeClass="event-ticket-modal-btn-close"
        submitClass="event-ticket-modal-btn-ok"
        formId="ticketForm"
        isLoading={loading}
      >
        <form
          className="event-ticket-form"
          onSubmit={handleSubmit(onSubmit)}
          id="ticketForm"
        >
          <Input
            CustomFormGroupCls="event-create-field"
            InputClassName="event-create-input"
            element="text"
            placeholder={TicketFormLanguage.FormLabal.ticketName.placeHolder}
            Register={register}
            Errors={errors}
            FieldName="name"
            Label={TicketFormLanguage.FormLabal.ticketName.label}
            ValidationArr={[
              { Type: "required" },
              { Type: "minLength", value: 3 },
            ]}
          />
          <div className="event-create-fields-grid">
            <Input
              CustomFormGroupCls="event-create-field"
              InputClassName="event-create-input"
              element="number"
              placeholder={TicketFormLanguage.FormLabal.quantity.placeHolder}
              Register={register}
              Errors={errors}
              FieldName="quantity"
              Label={TicketFormLanguage.FormLabal.quantity.label}
              ValidationArr={[
                { Type: "required" },
                { Type: "minLength", value: 1 },
              ]}
            />
            <Input
              CustomFormGroupCls="event-create-field"
              InputClassName="event-create-input"
              element="number"
              placeholder={TicketFormLanguage.FormLabal.price.placeHolder}
              Register={register}
              Errors={errors}
              FieldName="price"
              Label={TicketFormLanguage.FormLabal.price.label}
              ValidationArr={[
                { Type: "required" },
                { Type: "minLength", value: 1 },
                { Type: "maxLength", value: 15 },
              ]}
            />
          </div>

          <div className="event-create-fields-grid">
            <Input
              CustomFormGroupCls="event-create-field"
              InputClassName="event-create-input event-create-input--datetime"
              element="datetime-local"
              placeholder={
                TicketFormLanguage.FormLabal.salesStart.placeHolder
              }
              Register={register}
              Errors={errors}
              FieldName="salesStart"
              max={eventEndDateTime}
              Label={TicketFormLanguage.FormLabal.salesStart.label}
              ValidationArr={[{ Type: "required" }]}
            />

            <Input
              CustomFormGroupCls="event-create-field"
              InputClassName="event-create-input event-create-input--datetime"
              element="datetime-local"
              placeholder={TicketFormLanguage.FormLabal.salesEnd.placeHolder}
              Register={register}
              Errors={errors}
              FieldName="salesEnd"
              max={eventEndDateTime}
              Label={TicketFormLanguage.FormLabal.salesEnd.label}
              ValidationArr={[{ Type: "required" }]}
            />
          </div>
          <div className="event-ticket-valid-wrap">
            {tickets?.map((item, i) => {
              const rowErrors = getValidityRowErrors(item);
              const validFromHasError = Boolean(
                item?.startDateError ||
                  item?.currentDateError ||
                  item?.isBeforeEventValidation ||
                  item?.startDateGreater
              );
              const validTillHasError = Boolean(
                item?.error ||
                  item?.isBeforeEventValidationEnd ||
                  item?.isTicketEventStart
              );

              return (
              <div className="event-ticket-valid-row" key={`ticket-valid-${i}`}>
                <div
                  className={`event-create-field${
                    validFromHasError ? " has-error" : ""
                  }`}
                >
                  <label htmlFor={`ticketStart-${i}`}>Valid From*</label>
                  <input
                    id={`ticketStart-${i}`}
                    className="event-create-input event-create-input--datetime"
                    type="datetime-local"
                    placeholder={
                      TicketFormLanguage.FormLabal.ticketStart.placeHolder
                    }
                    min={eventStartDateTime}
                    max={eventEndDateTime}
                    aria-invalid={validFromHasError}
                    onChange={(e) =>
                      setTickets((prev) => {
                        const temp = [...prev];
                        const exist = temp.find((s, index) => index === i);
                        if (exist) {
                          exist.ticketStart = e.target.value;
                          return temp;
                        }
                      })
                    }
                    value={item?.ticketStart || ""}
                  />
                </div>
                <div
                  className={`event-create-field${
                    validTillHasError ? " has-error" : ""
                  }`}
                >
                  <label htmlFor={`ticketEnd-${i}`}>Valid Till*</label>
                  <input
                    id={`ticketEnd-${i}`}
                    type="datetime-local"
                    placeholder={
                      TicketFormLanguage.FormLabal.ticketStart.placeHolder
                    }
                    className="event-create-input event-create-input--datetime"
                    min={eventStartDateTime}
                    max={eventEndDateTime}
                    aria-invalid={validTillHasError}
                    onChange={(e) =>
                      setTickets((prev) => {
                        const temp = [...prev];
                        const exist = temp.find((s, index) => index === i);
                        if (exist) {
                          exist.ticketEnd = e.target.value;
                          return temp;
                        }
                      })
                    }
                    value={item?.ticketEnd || ""}
                  />
                </div>
                {i === 0 ? (
                  <button
                    disabled={loading}
                    type="button"
                    className="event-ticket-valid-btn is-add"
                    aria-label="Add validity period"
                    onClick={() => {
                      setTickets((prev) => {
                        return [
                          ...prev,
                          {
                            ticketStart: new Date().toISOString(),
                            ticketEnd: new Date().toISOString(),
                          },
                        ];
                      });
                    }}
                  >
                    <i className="las la-plus"></i>
                  </button>
                ) : tickets.length > 1 ? (
                  <button
                    type="button"
                    className="event-ticket-valid-btn is-remove"
                    aria-label="Remove validity period"
                    onClick={() => {
                      setTickets((prev) =>
                        prev.filter((s, index) => index !== i)
                      );
                    }}
                  >
                    <i className="las la-times"></i>
                  </button>
                ) : (
                  <span aria-hidden="true" />
                )}
                {rowErrors.length > 0 && (
                  <div className="event-ticket-valid-errors" role="alert">
                    {rowErrors.map((message) => (
                      <p key={message} className="event-ticket-field-error">
                        {message}
                      </p>
                    ))}
                  </div>
                )}
              </div>
            );
            })}
          </div>

          <section
            className="event-ticket-advanced"
            aria-labelledby="eventTicketAdvancedTitle"
          >
            <h3 className="event-ticket-advanced-title" id="eventTicketAdvancedTitle">
              {TicketFormLanguage.AdvancedSettiing}
            </h3>
            <Input
              CustomFormGroupCls="event-create-field"
              InputClassName="event-create-textarea event-ticket-description"
              element="textarea"
              rows="4"
              placeholder={TicketFormLanguage.FormLabal.description.placeHolder}
              Register={register}
              Errors={errors}
              FieldName="description"
              Label={TicketFormLanguage.FormLabal.description.label}
              ValidationArr={[
                { Type: "required" },
                { Type: "minLength", value: 3 },
              ]}
            />
            <div className="event-create-fields-grid">
              <Input
                CustomFormGroupCls="event-create-field"
                InputClassName="event-create-input"
                element="number"
                placeholder={
                  TicketFormLanguage.FormLabal.ticketPerOrder.placeHolder.minQty
                }
                Register={register}
                Errors={errors}
                FieldName="minTicketPerOrder"
                Label={TicketFormLanguage.FormLabal.ticketPerOrder.label}
                ValidationArr={[
                  { Type: "required" },
                  { Type: "minLength", value: 1 },
                  { Type: "maxLength", value: 50 },
                ]}
              />
              <Input
                CustomFormGroupCls="event-create-field"
                InputClassName="event-create-input"
                element="number"
                placeholder={
                  TicketFormLanguage.FormLabal.ticketPerOrder.placeHolder.maxQty
                }
                Register={register}
                Errors={errors}
                FieldName="maxTicketPerOrder"
                Label={TicketFormLanguage.FormLabal.ticketPerOrder.label}
                ValidationArr={[
                  { Type: "required" },
                  { Type: "minLength", value: 1 },
                  { Type: "maxLength", value: 50 },
                ]}
              />
            </div>
            {minMaxError && (
              <p className="event-ticket-field-error">{minMaxError}</p>
            )}

            <Input
              CustomFormGroupCls="event-create-field"
              InputClassName="event-create-input"
              element="text"
              placeholder={TicketFormLanguage.FormLabal.hotelLink.placeHolder}
              Register={register}
              Errors={errors}
              FieldName="hotellink"
              Label={TicketFormLanguage.FormLabal.hotelLink.label}
            />
          </section>
        </form>
      </ModalWrapper>
    </MainComponentWrapper>
  );
};

export default TicketForm;
